import { createContext, Component } from 'react'
import i18n from './index'
import { Api, LocalStorage } from '../Services'

const SUPPORTED_LANGUAGES = ['it', 'en', 'fr']
const STORAGE_KEY = 'ems-language'

export const LanguageContext = createContext()

export class LanguageContextProvider extends Component {
  constructor (props) {
    super(props)
    this.state = { language: i18n.language }
  }

  // persist=false: applica solo (es. lingua letta dal db al login)
  setLanguage = (lang, persist = true) => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) return
    localStorage.setItem(STORAGE_KEY, lang)
    i18n.changeLanguage(lang)
    this.setState({ language: lang })
    const userId = LocalStorage.get('_id')
    if (persist && userId) Api.patch(`/users/${userId}`, { lingua: lang })
  }

  render () {
    const { language } = this.state
    return (
      <LanguageContext.Provider value={{
        language,
        setLanguage: this.setLanguage,
        supportedLanguages: SUPPORTED_LANGUAGES
      }}>
        {this.props.children}
      </LanguageContext.Provider>
    )
  }
}

export const withLanguage = (WrappedComponent) => {
  return (props) => (
    <LanguageContext.Consumer>
      {(langContext) => <WrappedComponent {...props} langContext={langContext} />}
    </LanguageContext.Consumer>
  )
}
